import { render, staticRenderFns } from "./Synchronizer.vue?vue&type=template&id=533b75c8&"
import script from "./Synchronizer.vue?vue&type=script&lang=js&"
export * from "./Synchronizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports